module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-d61b3374d730e741e11a51fdee22d321.png";